import * as React from 'react';
import { Color, Text } from '@bb/elements-web';

type CalendarSyncButtonProps = {
  isAlmanacAuthenticated: boolean;
  isSyncButtonClicked: boolean;
  existingAlmanacEvent: boolean;
  startOauth: () => void;
  onCalendarSyncButtonClick: () => void;
  newDetailsPageDesign?: boolean;
};

const CalendarSyncButton: React.FunctionComponent<CalendarSyncButtonProps> = ({
  isAlmanacAuthenticated,
  isSyncButtonClicked,
  existingAlmanacEvent,
  startOauth,
  onCalendarSyncButtonClick,
  newDetailsPageDesign,
}) => {
  if (existingAlmanacEvent) {
    if (newDetailsPageDesign) {
      return (
        <div className="calendar-sync-success m-y-xs">
          <Text color="primary">Added to Calendar</Text>
        </div>
      );
    }
    return (
      <div className="calendar-sync-success m-y-xs">
        <i className="fa fa-calendar-plus-o"></i>{' '}
        <strong>Added to Calendar</strong>
      </div>
    );
  }

  if (isAlmanacAuthenticated) {
    if (isSyncButtonClicked) {
      return (
        <button className="btn btn-info btn-sm m-b-xs col-xs-12" disabled>
          <i className="fa fa-spinner fa-spin"></i>
        </button>
      );
    }
    if (newDetailsPageDesign) {
      return (
        <button
          style={{
            color: Color.PRIMARY,
          }}
          onClick={() => onCalendarSyncButtonClick()}
        >
          Add to Calendar
        </button>
      );
    }
    return (
      <button
        onClick={() => onCalendarSyncButtonClick()}
        className="btn btn-info btn-sm m-b-xs col-xs-12"
      >
        <i className="fa fa-calendar-plus-o"></i> Add to Calendar
      </button>
    );
  }

  return (
    <a onClick={() => startOauth()}>
      <Text color="primary" size="large">
        Add to Calendar
      </Text>
    </a>
  );
};

export default CalendarSyncButton;
